export default (app) => {
    let router = app.config.globalProperties.$router
    return {
        abreAjuda: async function ( { categoria, artigo, desenvolvedor } = {}) {
            let datetime = new Date()
            datetime.setDate(datetime.getDate() + 1) // adiciona 1 dia
            const ano = datetime.getFullYear(),
                mes = datetime.getMonth() + 1, // month: 0-11
                dia = datetime.getDate(),
                hora = datetime.getHours(),
                minuto = datetime.getMinutes(),
                segundo = datetime.getSeconds()

            // se menu principal
            if (!categoria && !artigo) {
                const obj = this.getURL()
                categoria = obj.categoria
                artigo = obj.artigo
            }

            // let url = 'http://localhost:8080'
            let url = 'http://quinlan.datacoper.com.br:8019'
            //if (process.env.NODE_ENV === 'production')
                url = 'https://central.vistra.com.br:8050' //quando estiver na central, substituir aqui

            const usuarioDEV = {
                id: 'vistra.dev',
                senha: 'D(:+,0:>YZc'
            }
            const usuarioPRO = {
                id: 'vistra.pro',
                senha: 'D(:+,0:>YZc'
            }
            const usuario = desenvolvedor ? usuarioDEV : usuarioPRO 

            // criptografa a chave URL safe pra adicionar na url
            let chave = `${ano}_${mes}_${dia}_${hora}_${minuto}_${segundo}|${usuario.id}|${usuario.senha}`
            let response = await app.config.globalProperties.$http.get("/Key/Encrypt?str="+ encodeURIComponent(chave))
            chave = response.data

            if (artigo) {
                //console.log("ajuda artigo:", artigo)
                url += `/go?autologin=${chave}&req=/artigo/${artigo}`
            } else if (categoria) {
                //console.log("ajuda categoria:", categoria)
                url += `/go?autologin=${chave}&req=/categoria/${categoria}`
            } else {
                //console.log("ajuda geral")
                url += `/login?autologin=${chave}`
            }
    
            // console.log("URL ajuda", url)
            var win = window.open(url, '_blank')
            win.focus();
        },
        getURL() {
            return router.currentRoute.value.meta?.ajuda || {}
        }
    }
}